import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button, Dialog, Tabs, InfiniteScroll } from 'antd-mobile-v5';
import { toWxMiniProgram } from '../../../api/createHttpRequest';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';

import prescription_icon from '../../../static/images_cso/prescription_icon.png';
import special_selected from '../../../static/images_cso/search/special_selected.png';
import excellent_selected from '../../../static/images_cso/search/excellent_selected.png';
import abroad_medicine from '../../../static/images_cso/search/abroad_medicine.png';

const api = new ApiCore();

const MultiMedicineList = (props: any) => {

    const [suggestList, setSuggestList] = useState<any>([]);

    useEffect(() => {
        let item = sessionStorage.getItem('multiMedicineListDrugs');
        document.title = '甄选产品包';
        if (item) {
            let orderDrugs = JSON.parse(item);
            setSuggestList(orderDrugs);
        }
        // initData();
        return () => {
        }
    }, [])

    const CureCollectSuggestionRender = () => {
        return (
        <div className={styles.cure_suggestion} >
            <div className={styles.cure_suggestion_content} >
                <div className={styles.search_content}>
                    <div className={styles.search_content_r}>
                        {
                         suggestList.map((val: any, key: number) => (
                            <div key={key} className={`${styles.suggest_item}`} >
                                <div className={styles.search_content_r_1_wrap}>
                                    <img className={styles.search_content_r_1} src={val.icon || prescription_icon} alt="" />
                                    {
                                        val.channelType == 1 && 
                                        <img className={styles.search_content_r_1_1_b} src={abroad_medicine} alt="" />
                                    }   
                                </div>
                                <div  className={styles.search_content_r_2}>
                                    <div className={styles.search_content_r_2_t}>
                                        {
                                            val.pickType == 1 && 
                                            <img className={styles.special_selected} src={special_selected} alt="" />  
                                        }
                                        {
                                            val.pickType == 2 && 
                                            <img className={styles.special_selected} src={excellent_selected} alt="" />  
                                        }
                                       <span className={styles.title} >{val.name}</span>
                                    </div>
                                    <div className={styles.search_content_r_2_b}>{val.size}</div>
                                    <div className={styles.search_content_r_2_b}>{val.manufacturerName}</div>
                                    <div className={styles.search_content_r_2_b_b}>
                                        <div className={styles.medicine_price}>
                                            <span className={styles.unit}>¥</span>
                                            <span className={styles.price}>{val.price}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        }
                    </div>
                </div>
            </div>
        </div>)
    }

    return (
        <div className={styles.multi_medicine_list_content}>
            {
                CureCollectSuggestionRender()
            }
        </div>
    )
}

export default withRouter(MultiMedicineList);